import type {UserImageVOResponse} from '@Libraries/user-image-library';

export const EDIT_WITH_AI_EDITED_IMAGES_GRID_ID = 'edit-with-ai-edited-images-grid';
export const EDIT_WITH_AI_EDITED_IMAGES_ENDPOINT = 'ai/getEditedImagesByUser';
export const EDIT_WITH_AI_DELETE_EDITED_IMAGE_ENDPOINT = 'ai/deleteEditedImage';
export const EDIT_WITH_AI_EDITED_IMAGES_LOAD_BATCH_SIZE = 30;
export const EDIT_WITH_AI_EDIT_SKELETON_ID_PREFIX = 'edit-with-ai-edit-skeleton-';

export interface EditedImageVOResponse extends UserImageVOResponse {
  prompt: string;
}
